import { Button } from "@components/ngg";
import { HeartIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { CustomProduct } from "@apptus/esales-api";
import { MouseEvent } from "react";
import useAddWishlistItem from "../../hooks/useAddWishlistItem";
import useDeleteWishlistItem from "../../hooks/useDeleteWishlistItem";
import useWishlistItem from "../../hooks/useWishlistItem";

const WishlistPDPToggle = ({
  productId,
  variantId,
}: {
  productId: string;
  variantId: string;
}) => {
  const product = {
    key: productId,
    variants: [{ key: variantId }],
  } as CustomProduct;
  const { data: wishlistItem } = useWishlistItem(product);
  const { addWishlistItemAsync, isPending: isAdding } = useAddWishlistItem();
  const { deleteWishlistItemAsync, isPending: isDeleting } =
    useDeleteWishlistItem();

  async function onClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();
    if (wishlistItem) {
      await deleteWishlistItemAsync(wishlistItem);
    } else {
      await addWishlistItemAsync(product);
    }
  }

  return (
    <Button
      type="button"
      disabled={isDeleting || isAdding}
      onClick={onClick}
      className="group w-10 border border-black text-xl transition hover:opacity-75 lg:w-12"
    >
      <HeartIcon
        strokeWidth={1}
        className={cn("size-5", Boolean(wishlistItem) && "fill-current")}
      />
    </Button>
  );
};

export default WishlistPDPToggle;
